import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

export interface PolicyPageData {
  site: any;
  contentBySection: any;
  page: any;
}

/**
 * Resolves policy page data before the route activates so that:
 * 1) Content is available for SSR (when enabled), so Google gets full HTML.
 * 2) No empty shell then late load — avoids timeout / "page doesn't work" in crawlers.
 */
export const policyPageResolver: ResolveFn<PolicyPageData | null> = (route: ActivatedRouteSnapshot) => {
  const tfm = inject(TFMService);
  const slug = route.parent?.params?.['slug']?.toLowerCase();
  if (!slug) {
    return Promise.resolve(null);
  }

  return Promise.all([
    tfm.getSite(),
    tfm.getContentBySection(slug),
    tfm.getPages()
  ]).then(([site, contentBySection, pagesRes]: [any, { content?: any } | null, any]) => {
    const pages = (pagesRes?.content || []).filter((p: any) => p?.seo?.alias?.toLowerCase() === slug);
    const page = pages.length === 1 ? pages[0] : (contentBySection?.content ?? null);
    if (site) {
      site.profile = tfm.getSiteProfile(site.profileID);
    }
    return { site, contentBySection, page };
  });
};
